export default "__VITE_ASSET__MistCis9__"